import React, { useState, useEffect, useContext } from "react";
import { useSelector } from 'react-redux';
// import * as actions from '../redux/actionTypes';
import { AppContext } from '../components/context/AppContext';
import Slider from "react-slick";
import Card from "./card/Card";
import hotIcon from "../assets/hot-icon.svg";
// import { setFlashSaleTimer } from '../redux/actionCreators';

const settings = {
  // centerMode: true,
  dots: false,
  infinite: true,
  easing: "ease-in-out",
  speed: 500,
  slidesToShow: 5,
  swipeToSlide: true,
  centerPadding: "0",
  // variableWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const FlashSale = () => {
  const { setIsOpenFlashSale } = useContext(AppContext)
  const { items, timerFlashSale } = useSelector(state => state.flashSale);
  const [startTimer] = useState(new Date(timerFlashSale.startTimer).getTime());
  const [countdownDate] = useState(new Date(timerFlashSale.endTimer).getTime());
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const updateCountdown = () => {

    const currentTime = new Date().getTime();
    if (countdownDate && startTimer < currentTime) {
      const distanceToDate = countdownDate - currentTime;
      let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor(
        (distanceToDate % (1000 * 60 * 60)) / (1000 * 60)
      );
      let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

      const numbersToAddZeroTo = [1, 2, 3, 4, 5, 6, 7, 8, 9];

      if (numbersToAddZeroTo.includes(hours)) {
        hours = `0${hours}`;
      }

      if (numbersToAddZeroTo.includes(minutes)) {
        minutes = `0${minutes}`;
      }

      if (numbersToAddZeroTo.includes(seconds)) {
        seconds = `0${seconds}`;
      }
      setDays(days);
      setHours(hours);
      setMinutes(minutes);
      setSeconds(seconds);

      if (hours < 0) {
        setIsOpenFlashSale(false)
      } else {
        setIsOpenFlashSale(true)
      }
    } else {
      setIsOpenFlashSale(false)
    }
  };

  useEffect(() => {
    setInterval(() => updateCountdown(), 1000);
  });

  return (
    <div className="flash-sale container">
      <div className="container">
        <div className="flash-sale-head">
          <h3>Flash Sale<span><img src={hotIcon} alt="hot icon" />Hot!</span></h3>
          <div className="timer">
            Berakhir dalam :
          <div className="time">
              {hours || "00"} : {minutes || "00"} : {seconds || '00'}
            </div>
          </div>
          <p className="text-more">Lihat Semua</p>
        </div>
        <div>
          <Slider {...settings}>
            {items.map((product) => (
              <Card
                key={product.id}
                img={product.img}
                alt={product.alt}
                productName={product.productName}
                qty={product.qty}
                discount={product.discount}
                discountPrice={product.discountPrice}
                actualPrice={product.actualPrice}
              />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default FlashSale;
